module.exports = __webpack_public_path__ + "static/media/sample-policy-document.f079265c.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/docs/sample-policy-document.pdf
// module id = 468
// module chunks = 0